<div
  class="flex md:justify-center align-center"
  id="dashboard__performance-item"
>
  <div class="font-bold">
    <p class="text-[2rem]">{{ value | number: "1.0-4" }} {{ currency }}</p>
    <p class="text-grayscale-heavy text-[1.25rem] font-medium">
      {{ valueName }}
    </p>
    <er-direction-indicator
      [value]="percent || 0"
      [comparedWith]="comparedWith"
      [upDirectionLabel]="upDirectionLabel"
      [downDirectionLabel]="downDirectionLabel"
    ></er-direction-indicator>
  </div>
</div>
